import { __awaiter } from './_virtual/_tslib.js';
import { debugSubgraphError } from './utils/errors.js';
import { namehash } from './utils/normalise.js';

const generateSelection = selection => ({
  kind: "Field",
  name: {
    kind: "Name",
    value: selection
  },
  arguments: [],
  directives: [],
  alias: undefined,
  selectionSet: undefined
});
const enter = node => {
  let hasName = false;
  let hasId = false;
  for (const selection of node.selections) {
    if ("name" in selection) {
      if (selection.name.value === "name") hasName = true;else if (selection.name.value === "id") hasId = true;
    }
  }
  if (hasName && !hasId) {
    // eslint-disable-next-line no-param-reassign
    node.selections = [...node.selections, generateSelection("id")];
    return node;
  }
};
const requestMiddleware = (visit, parse, print) => request => {
  // Debug here because response middleware will resolve any error thrown
  debugSubgraphError(request);
  const requestBody = JSON.parse(request.body);
  const rawQuery = requestBody.query;
  const parsedQuery = parse(rawQuery);
  const updatedQuery = visit(parsedQuery, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SelectionSet: {
      enter
    }
  });
  return Object.assign(Object.assign({}, request), {
    body: JSON.stringify(Object.assign(Object.assign({}, requestBody), {
      query: print(updatedQuery)
    }))
  });
};
const responseMiddleware = traverse => response => {
  // If response is of type error, we do not need to further process it
  if (response instanceof Error) return response;
  // eslint-disable-next-line func-names
  traverse(response).forEach(function (responseItem) {
    if (responseItem instanceof Object && responseItem.name) {
      // Name already in hashed form
      if (responseItem.name && responseItem.name.includes("[")) {
        return;
      }
      let hashedName = "[Invalid ENS Name]";
      try {
        hashedName = namehash(responseItem.name);
      } catch (e) {
        this.update(Object.assign(Object.assign({}, responseItem), {
          name: hashedName,
          invalidName: true
        }));
        return;
      }
      if (responseItem.id !== hashedName) {
        this.update(Object.assign(Object.assign({}, responseItem), {
          name: hashedName,
          invalidName: true
        }));
      }
    }
  });
  return response;
};
class GqlManager {
  constructor() {
    // eslint-disable-next-line class-methods-use-this
    this.gql = query => query.join();
    this.client = {
      request: () => Promise.resolve(null)
    };
    this.setUrl = url => __awaiter(this, void 0, void 0, function* () {
      if (url) {
        const [imported, traverse, {
          visit,
          parse,
          print
        }] = yield Promise.all([import('graphql-request'), import('traverse'), import('graphql/language')]);
        this.client = new imported.GraphQLClient(url, {
          requestMiddleware: requestMiddleware(visit, parse, print)
          // responseMiddleware: responseMiddleware(traverse.default),
        });

        this.gql = imported.gql;
      } else {
        this.client = {
          request: () => Promise.resolve(null)
        };
        this.gql = query => query.join();
      }
    });
  }
}

export { GqlManager as default, enter, requestMiddleware, responseMiddleware };
